import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, CardBody, Card, Table, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { setRequireCloseModal } from '../../../slices/personalProtectiveEquipment/reducer';
import { getEstablishmentList, getPersonList, } from '../../../helpers/establishment/backend_helper';
import { updatePersonalProtectiveEquipment, addNewPersonalProtectiveEquipment, getWarehouseItemList, reserveWarehouseItem, uploadFoldersFile, getPersonalProtectiveEquipmentByPersonId, getUserByRoles, sendNewEmailMessage, addNewBulkNotification, releaseWarehouseItem, deleteFile, establishmentUser, getPersonalProtectiveEquipmentStatusDefaultRegularization, } from '../../../slices/thunks';
import OSelect from '../../../Components/OElements/OSelect';
import {
	getPersonalProtectiveEquipmentReasonList,
	getPersonalProtectiveEquipmentStatusList as getPersonalProtectiveEquipmentStatusListApi,
	getWarehouseList
} from '../../../helpers/warehouse/backend_helper';
import SimpleBar from 'simplebar-react';
import useLogoLoader from '../../../Components/Hooks/useLogoLoaderHooks';
import { generatePDF } from '../Document/PPEDocument';
import useFileType from '../../../Components/Hooks/useFileTypeHooks';
import useFolderPaths from '../../../Components/Hooks/useFolderPathsHooks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import OInput from '../../../Components/OElements/OInput';
import { setWarehouseItemList } from '../../../slices/warehouseItem/reducer';

const PersonalProtectiveEquipmentForm = ({ dataPersonalProtectiveEquipment, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();
	const { logoSrc } = useLogoLoader('login');
	const [folderPaths, setFolderPaths] = useState([]);
	const [dataListPerson, setDataListPerson] = useState([]);
	const [selectedEstablishment, setSelectedEstablishment] = useState(null);
	const [selectedReason, setSelectedReason] = useState(null);
	const [selectedCompany, setSelectedCompany] = useState(null);
	const [selectedWarehouse, setSelectedWarehouse] = useState(null);
	const [selectedPerson, setSelectedPerson] = useState(null);
	const [loading, setLoading] = useState(false);
	const [costCenterList, setCostCenterList] = useState([]);
	const [costCenterDefault, setCostCenterDefault] = useState(null);


	const selectorPersonalProtectiveEquipment = createSelector(
		state => state.PersonalProtectiveEquipments,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
			personalProtectiveEquipmentList: data.personalProtectiveEquipmentList,
			personalProtectiveEquipmentStatusDefaultRegularization: data.personalProtectiveEquipmentStatusDefaultRegularization,
			isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading: data.isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading,
			isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess: data.isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess
		})
	);
	const {
		isAdding,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
		personalProtectiveEquipmentList,
		personalProtectiveEquipmentStatusDefaultRegularization,
		isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading,
		isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess
	} = useSelector(selectorPersonalProtectiveEquipment);


	const selectorItems = createSelector(
		state => state.WarehouseItems,
		data => ({
			dataList: data.warehouseItemList,
		})
	);
	const { dataList = [] } = useSelector(selectorItems);
	const { file_type } = useFileType('EPP');

	const selectorUser = createSelector(
		state => state.Roles,
		result => ({
			users: result.itemUserRoleList,
		})
	);
	const { users } = useSelector(selectorUser);


	const [to, setTo] = useState([]);
	const [cc, setCC] = useState([]);

	useEffect(() => {
		const fetchDataTo = async () => {
			const roles = ['BDG'];
			const params = { roles: roles.join(',') };

			try {
				const response = await dispatch(getUserByRoles(params)).unwrap();
				setTo(response);
			} catch (error) {
				console.error('Error al obtener usuarios TO:', error);
			}
		};

		const fetchDataCc = async () => {
			const roles = ['SSO'];
			const params = { roles: roles.join(',') };

			try {
				const response = await dispatch(getUserByRoles(params)).unwrap();
				setCC(response);
			} catch (error) {
				console.error('Error al obtener usuarios CC:', error);
			}
		};

		fetchDataTo();
		fetchDataCc();
	}, [dispatch]);

	useEffect(() => {
		// Load EPP initial
		dispatch(getPersonalProtectiveEquipmentStatusDefaultRegularization({codes: 'AGD'}))
	}, [])

	const uploadDocument = async (file, folderPaths, fileTypeId, establishmentId) => {
		if (!(file instanceof File)) {
			throw new Error("El archivo seleccionado no es válido.");
		}

		const formData = new FormData();
		formData.append("file", file);
		formData.append("file_type_id", fileTypeId);
		formData.append("establishment_id", establishmentId);

		folderPaths.forEach(path => formData.append("folder_paths", path));

		// console.log("FormData antes de la subida:");
		// for (let pair of formData.entries()) {
		// 	console.log(pair[0], pair[1]);
		// }

		try {
			const response = await dispatch(uploadFoldersFile(formData)).unwrap();
			return response;
		} catch (error) {
			console.error("Error uploading file:", error);
			throw error;
		}
	};

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			person_id: '',
			management_id: dataPersonalProtectiveEquipment?.management_id || '',
			establishment_id: dataPersonalProtectiveEquipment?.establishment_id || '',
			warehouse_id: dataPersonalProtectiveEquipment?.warehouse_id || '',
			// assigned_items: dataPersonalProtectiveEquipment?.date_ini || '',
			assignment_date: dataPersonalProtectiveEquipment?.assignment_date || '',
			personal_protective_equipment_reason_id: dataPersonalProtectiveEquipment?.personal_protective_equipment_reason_id || '',
			personal_protective_equipment_status_id: dataPersonalProtectiveEquipment?.personal_protective_equipment_status_id || '',
			reason: dataPersonalProtectiveEquipment?.reason || '',
			cost_center_id: dataPersonalProtectiveEquipment?.cost_center_id || '',
			change_to_delivered: null,
			is_regularization: dataPersonalProtectiveEquipment?.is_regularization || false,
		},
		validationSchema: Yup.object({
			person_id: Yup.string().required('Campo requerido'),
			establishment_id: Yup.string().required('Campo requerido'),
			personal_protective_equipment_reason_id: Yup.string().required('Campo requerido'),
			warehouse_id: Yup.string().required('Campo requerido'),
			assignment_date: Yup.string().required('Campo requerido'),
			reason: Yup.string().nullable(),
			cost_center_id: Yup.string().required('Campo requerido'),
			personal_protective_equipment_status_id: Yup.string().test(
				'required-if-regularization',
				'Campo requerido',
				function(value) {
					const { is_regularization } = this.parent;
					if (is_regularization) {
						return !!value && value.trim() !== '';
					}
					return true;
				}
			),
		}),
		onSubmit: async values => {
			setLoading(true);

			// Validar que haya al menos un ítem seleccionado
			if (Object.keys(selectedItems).length === 0) {
				toast.error('Debe seleccionar al menos un ítem para asignar.');
				setLoading(false);
				return;
			}


			// Construir el arreglo assigned_items basado en los ítems seleccionados
			const assignedItems = Object.keys(selectedItems).map(itemId => {
				const item = dataList.find(i => i._id === itemId);

				return {
					warehouse_id: values.warehouse_id,
					warehouse_code: selectedWarehouse.code_sap,
					warehouse_group_id: item.warehouse_group_id,
					warehouse_group_code: item.warehouse_group.code_sap,
					warehouse_item_id: item._id,
					warehouse_category_name: item.warehouse_category?.name || '',
					name: item.name || '',
					description: item.description || '',
					quantity: selectedItems[itemId].quantity || 1,
					quantity_available: selectedItems[itemId].quantity || 1,
					size: item.size || '',
					color: item.color || '',
					price: item.price || 0,
					unit_measurement_name: item.unit_measurement?.name || '',
				};
			});
			
			// Crear el objeto final con la estructura solicitada
			const formData = {
				person_id: values.person_id,
				cost_center_id: values.cost_center_id || null,
				management_id: selectedPerson.management?._id || null,
				establishment_id: values.establishment_id,
				personal_protective_equipment_reason_id: values.personal_protective_equipment_reason_id,
				personal_protective_equipment_status_id: values.personal_protective_equipment_status_id,
				reason: values.reason,
				warehouse_id: values.warehouse_id,
				assigned_items: assignedItems,
				assignment_date: values.assignment_date,
				delivery_date: values.delivery_date,
				...(isEdit && { _id: dataPersonalProtectiveEquipment._id }),
				change_to_delivered: values.change_to_delivered,
				is_regularization: values.is_regularization
			};


			try {

				const file = await generatePDF(
					logoSrc,
					{
						code: 'RG-RH-03',
						generation_date: '01-01-2025',
						modification_date: '01-01-2025',
						scope: 'Toda la Organización',
						status: 'Documento Controlado',
						version: '05',
						establishment: {
							name: selectedEstablishment.name
						},
						person: {
							name: selectedPerson.name,
							rut: selectedPerson.rut
						},
						items: assignedItems
					}
				);

				let documents = null;
				if (file) {
					const folder = '/' + selectedEstablishment.establishment_type.name + '/' + (selectedEstablishment.code_siep ? selectedEstablishment.code_siep + ' - ' : '') + selectedEstablishment.name + '/Abastecimiento/EPP/Entrega';
					const updatedFolderPaths = [...folderPaths, folder];
					setFolderPaths(updatedFolderPaths);

					try {
						documents = await uploadDocument(file, updatedFolderPaths, file_type._id, values.establishment_id);
					} catch (error) {
						return;
					}
					const document = documents[documents.length - 1];

					if (document?._id) {
						if (dataPersonalProtectiveEquipment?.document_id != null) { 
							dispatch(deleteFile(dataPersonalProtectiveEquipment.document_id))
						}
						formData.document_id = document._id;
					}

					let epp;
					if (isEdit) {
						epp = await dispatch(updatePersonalProtectiveEquipment(formData)).unwrap();
					} else {
						epp = await dispatch(addNewPersonalProtectiveEquipment(formData)).unwrap();
					}

					let subject = 'Asignación de EPP';

					let body = `<div style="max-width: 600px; margin: auto; font-family: Arial, sans-serif; line-height: 1.6; color: #333; background-color: #f9f9f9; padding: 20px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
									
														<div style="text-align: center; margin-bottom: 20px;">
																<h1 style="color: COLOR_SECONDARY;">Asignación de Elementos de Protección Personal</h1>
														</div> 

														<p style="text-align: justify;">
															Informamos que al(la) trabajador(a), Sr(a) <b>${selectedPerson.name.toUpperCase()}</b>, se le ha realizado la asignación de Elementos de Protección Personal (EPP) bajo el código <b>${epp.code}</b>, desde <b>${selectedWarehouse.name.toUpperCase()}</b>, con el objetivo de resguardar su seguridad durante el desempeño de sus funciones. A continuación, se detallan los elementos por entregar.
														</p>


											
														<table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
															<tr>
																<th style="padding: 10px; border: 1px solid #ddd; text-align: center;">Elemento</th>
																<th style="padding: 10px; border: 1px solid #ddd; text-align: center;">Cantidad</th>
															</tr>
															${assignedItems.map(item => `
															<tr> 
																<td style="padding: 10px; border: 1px solid #ddd;">${item.name}</td>
																<td style="padding: 10px; border: 1px solid #ddd;">${item.quantity} ${item.unit_measurement_name}</td>
															</tr>`).join('')}
														</table>

														<div style="margin-top: 30px; text-align: center; font-size: 0.8em;">
																<p>Si tienes alguna pregunta o necesitas asistencia, por favor <a href="mailto:ayuda@openlink.cl" style="color: COLOR_SECONDARY;">contáctanos</a>.</p>
																<p>Gracias. Equipo de Openlink.</p>
														</div>
												</div>`;


					const date = new Date(epp.assignment_date);
					let message =
						'Asignación de EPP. Código: ' + epp.code +
						' Nombre: ' + selectedPerson.name +
						' Fecha Asignación: ' + date.toLocaleDateString();

					if (to.length > 0) {
						const uniqueEmailsTo = [...new Set(to.map(user => user.email))].join(',');
						const uniqueEmailsCc = [...new Set(cc.map(user => user.email))].join(',');
						const message_email = {
							to_email: uniqueEmailsTo,
							subject: subject,
							body: body,
							cc_email: uniqueEmailsCc
						};
						dispatch(sendNewEmailMessage(message_email));

						const user_ids = [...new Set(to.map(user => user._id))];
						const message_notification = {
							title: subject,
							message: message,
							notification_priority_code: 'M',
							notification_type_code: 'INF',
							user_ids: user_ids
						}
						dispatch(addNewBulkNotification(message_notification));
					}

				}

				setLoading(false);
				dispatch(setRequireCloseModal(true));
				handleToggleModal();


			} catch (err) {
				console.error('Error al guardar:', err);
				toast.error('Hubo un error al guardar la información');
			}
		}
	});

	// Estado para filtros y selección
	const [selectedItems, setSelectedItems] = useState({});
	const [selectedItemsLast, setSelectedItemsLast] = useState({});
	const [hasSavedInitialAssignedItems, setHasSavedInitialAssignedItems] = useState(false);
	const [filteredDataList, setFilteredDataList] = useState(dataList);

	const [sizeFilter, setSizeFilter] = useState(null);
	const [categoryFilter, setCategoryFilter] = useState(null);
	const [phraseFilter, setPhraseFilter] = useState(null);

	const [sizeOptions, setSizeOptions] = useState([]);
	const [categoryOptions, setCategoryOptions] = useState([]);

	useEffect(() => {
		if (isEdit && dataPersonalProtectiveEquipment && dataPersonalProtectiveEquipment._id && dataPersonalProtectiveEquipment.assigned_items && !hasSavedInitialAssignedItems) {
			setSelectedItemsLast(dataPersonalProtectiveEquipment.assigned_items);
			setHasSavedInitialAssignedItems(true);
		}
	}, [isEdit, dataPersonalProtectiveEquipment]);

	useEffect(() => {
		if(!isOpen) {
			setFilteredDataList([]);
			dispatch(setWarehouseItemList([]));
		};
	}, [isOpen])

	function restoreAvailableStockItems(warehouseItems, assignedItems){
		// Restore item availability by adding back previously assigned quantities
		// This resets stock levels before applying a new reservation or validation
		if(assignedItems){
			const adjustedItemsAvailableStock = warehouseItems.map((warehouseItem) => {
				const item_assigned_found = assignedItems.find(
					assigned_item => 
						assigned_item.warehouse_item_id == warehouseItem._id
				);
				return (
					item_assigned_found
						? {
							...warehouseItem, 
							available: (warehouseItem.available + item_assigned_found.quantity)
						} 
						: warehouseItem
					);
			})
			return adjustedItemsAvailableStock
		}else{
			return warehouseItems;	
		}
	}

	useEffect(() => {
		if (!dataList || dataList.length === 0) {
			setFilteredDataList([]);
			setSizeOptions([]);
			setCategoryOptions([]);
			setPhraseFilter(null);
			return;
		}

		// Recalculate available stock by restoring previously assigned quantities
		const adjustedItemsAvailableStock = restoreAvailableStockItems(
			dataList, 
			dataPersonalProtectiveEquipment.assigned_items
		);
		
		setFilteredDataList(adjustedItemsAvailableStock);

		// Crear opciones para los selects
		const newSizeOptions = [...new Set(dataList.map(item => item.size).filter(Boolean))].map(size => ({
			label: size,
			value: size,
		}));

		const newCategoryOptions = [...new Set(dataList.map(item => item.warehouse_category?.name).filter(Boolean))].map(category => ({
			label: category,
			value: category,
		}));

		setSizeOptions(newSizeOptions);
		setCategoryOptions(newCategoryOptions);

	}, [dataList]);

	useEffect(() => {
		const filteredList = dataList.filter(item =>
			(
				(item.available > 0) ||
				(validation.values.is_regularization)
			) &&
			(!categoryFilter || item.warehouse_category?.name === categoryFilter) &&
			(!sizeFilter || item.size === sizeFilter) &&
			(!phraseFilter || item.name?.toLowerCase().includes(phraseFilter.toLowerCase()))
		);

		// Recalculate available stock by restoring previously assigned quantities
		const adjustedItemsAvailableStock = restoreAvailableStockItems(
			filteredList, 
			dataPersonalProtectiveEquipment.assigned_items
		);

		setFilteredDataList(adjustedItemsAvailableStock);

	}, [categoryFilter, sizeFilter, phraseFilter]);



	useEffect(() => {
		setSelectedPerson(null);
		validation.setFieldValue('person_id', null);
		setSelectedCompany(selectedEstablishment ? selectedEstablishment.company_id : null);
	}, [selectedEstablishment]);




	useEffect(() => {
		if (selectedPerson) {
			dispatch(getPersonalProtectiveEquipmentByPersonId({ person_id: selectedPerson?._id }));
		}
	}, [selectedPerson]);



	useEffect(() => {
		if (personalProtectiveEquipmentList.length > 0 && selectedPerson) {
			const formattedData = personalProtectiveEquipmentList.flatMap((item) =>
				item.assigned_items.map((assignedItem) => ({
					personal_protective_equipment_status: item.personal_protective_equipment_status,
					code: item.code,
					delivery_date: item.delivery_date ?? null,
					establishment_name: item.establishment?.name ?? "Desconocido",
					quantity: assignedItem.quantity,
					unit_measurement_name: assignedItem.unit_measurement_name,
					name: assignedItem.name,
					size: assignedItem.size,
					price: assignedItem.price,
					warehouse: item.warehouse?.name ?? "No asignada",
					// price : item.
				}))
			);

			setDataListPerson(formattedData);
		} else {
			setDataListPerson([]);
		}
	}, [personalProtectiveEquipmentList, selectedPerson]);


	useEffect(() => {
		if (dataPersonalProtectiveEquipment && dataPersonalProtectiveEquipment._id) {
			dataPersonalProtectiveEquipment.assigned_items.forEach(item => {
				setSelectedItems((prev) => ({
					...prev,
					[item.warehouse_item_id]: { quantity: item.quantity || 1 },
				}));
			});
		}

	}, [dataPersonalProtectiveEquipment]);

	const handlePhraseFilter = (e) => {
		const { value } = e.target;
		setPhraseFilter(value);
	};

	const handleCategoryFilter = (optionSelected) => {
		if (optionSelected) {
			setCategoryFilter(optionSelected.warehouse_category?.name);
		} else {
			setCategoryFilter(null); // Si no hay selección, establecer en null
		}
	};

	const handleSizeFilter = (optionSelected) => {
		if (optionSelected) {
			setSizeFilter(optionSelected.size);
		} else {
			setSizeFilter(null); // Si no hay selección, establecer en null
		}
	};


	// Cargar ítems al seleccionar bodega
	useEffect(() => {
		if (validation.values.warehouse_id) {
			dispatch(
				getWarehouseItemList({
					warehouse_id: validation.values.warehouse_id,
					all: (
						validation.values.is_regularization
						? true
						: false
					) 
				})
			);
		}
		else {
			setFilteredDataList([])
		}
	}, [
		validation.values.warehouse_id,
		validation.values.is_regularization
	]);


	// Manejar selección de ítems
	const handleItemSelect = (itemId, available) => {
		if (available > 0 || validation.values.is_regularization ) {
			setSelectedItems((prev) => {
				const newItems = { ...prev };
				if (newItems[itemId]) {
					delete newItems[itemId];
				} else {
					newItems[itemId] = { quantity: 1 };
				}
				return newItems;
			});
		}
	};

	// Manejar cambio de cantidad
	const handleQuantityChange = (itemId, value, available) => {
		const quantity = (validation.values.is_regularization 
				? Number(value)
				: (Math.max(1, Math.min(available, Number(value) || 1)))
		);
		
		setSelectedItems((prev) => ({
			...prev,
			[itemId]: { quantity },
		}));
	};

	useEffect(() => {
		const costCenterAvailableList = [
			...(
				selectedPerson?.cost_center ? 
				[
					{
						value: selectedPerson.cost_center._id,
						label: (
							selectedPerson.cost_center.name +
							': ' +
							selectedPerson.cost_center.code
						),
						item: {
							...selectedPerson.cost_center,
							...{is_person: true}
						}
					}
				] : []
			),
			...(
				selectedEstablishment?.cost_center ? 
				[
					{
						value: selectedEstablishment.cost_center._id,
						label: (
							selectedEstablishment.cost_center.name +
							': ' +
							selectedEstablishment.cost_center.code
						),
						item: {
							...selectedEstablishment.cost_center,
							...{is_person: false}
						}
					}
				] : []
			)
		];
		setCostCenterList(costCenterAvailableList);
	}, [
		selectedPerson, 
		selectedEstablishment
	])

	useEffect(() => {
		if(costCenterList){
			const costCenterPerson = costCenterList.find((item) => item.item.is_person == true);
			if(costCenterPerson) setCostCenterDefault(costCenterPerson);
		}else{

		}
	}, [costCenterList])

	useEffect(() => {
		if(!selectedPerson){
			setCostCenterDefault(null);
			validation.setFieldValue('cost_center_id', '');
		}
	}, [selectedPerson])

	useEffect(() => {
		if(!validation.values.is_regularization && !isEdit){
			validation.setFieldValue('personal_protective_equipment_status_id', '', false);
		}
	}, [validation.values.is_regularization])

	const columns = useMemo(
		() => [
			{ header: 'Ítem', accessorKey: 'name', size: 'auto' },
			{ header: 'Cantidad', accessorKey: 'quantity', size: 'auto' },
			{ header: 'Unidad', accessorKey: 'unit_measurement_name', size: 'auto' },
			{ header: 'Talla', accessorKey: 'size', size: 'auto' }, {
				header: 'Estado', accessorKey: 'personal_protective_equipment_status_name', size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.personal_protective_equipment_status
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
								{status
									? status.name
									: ''}
							</span>
						</div>
					);
				},
			},
			{ header: 'code', accessorKey: 'code', size: 'auto' },
			{ header: 'Fecha Entrega', accessorKey: 'delivery_date', dataType: 'datetime', size: 'auto' },
			{ header: 'Establecimiento', accessorKey: 'establishment_name', size: 'auto' },
		],
	);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={3}>
								<OSelect
									key={'establishment_id'}
									label='Establecimiento de Destino'
									id='establishment_id'
									name='establishment_id'
									isRequired={true}
									value={dataPersonalProtectiveEquipment?.establishment_id || ''}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									onSelect={setSelectedEstablishment}
									requestApi={() => getEstablishmentList({ status_code: 'ACT' })}
									validation={validation}
								/>
							</Col>
							<Col sm={2}>
								<DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
									<DatePickerInput
										label={
											<span>
												Fecha de Asignación <span style={{ color: 'red' }}>*</span>
											</span>
										}
										id='assignment_date'
										name='assignment_date'
										placeholder="Seleccione una fecha"
										value={
											validation.values.assignment_date
												? new Date(validation.values.assignment_date)
												: null
										}
										onChange={(date) => { validation.setFieldValue("assignment_date", date); }}
										onBlur={validation.handleBlur}
										valueFormat='DD-MM-YYYY'
										maxDate={new Date()}
										// minDate={new Date(new Date().setDate(new Date().getDate() - 10))} // Set minDate to 5 days before today
										error={
											validation.touched['assignment_date'] && validation.errors['assignment_date']
												? validation.errors['assignment_date']
												: ''
										}
										clearable={true}
									/>
								</DatesProvider>
							</Col>

							<Col lg={3}>
								<OSelect
									key={'personal_protective_equipment_reason_id'}
									label='Motivo'
									id='personal_protective_equipment_reason_id'
									name='personal_protective_equipment_reason_id'
									isRequired={true}
									value={dataPersonalProtectiveEquipment?.personal_protective_equipment_reason_id || ''}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									onSelect={setSelectedReason}
									requestApi={() => getPersonalProtectiveEquipmentReasonList({ returnable: false })}
									validation={validation}
								/>
							</Col>
							<Col lg={4} hidden={selectedReason?.code != 'IA'}>
								<OInput
									name='reason'
									label='Detalle del motivo'
									type='text'
									placeholder='Ingrese un detalle del motivo'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
						</Row>

						<Row className='g-3 pt-3'>
							<Col lg={3}>
								<OSelect
									key={(
										'person_id' +
										selectedCompany || ''
									)}
									label='Persona'
									id='person_id'
									name='person_id'
									isRequired={true}
									value={dataPersonalProtectiveEquipment?.person_id || ''}
									handleLabelOptions={(item) => `${item.rut ? item.rut : 'S/RUT'} ${item.name}`}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									onSelect={setSelectedPerson}
									requestApi={() => getPersonList({ company_id: selectedCompany })}
									validation={validation}
								/>
							</Col>

							<Col lg={3}>
								<OInput
									name='management_position_id'
									label='Cargo'
									type='text'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
									disabled={true}
									value={selectedPerson?.management_position ? selectedPerson.management_position?.name.toUpperCase() : '-'}
								/>
							</Col>
							<Col lg={3}>
								<OInput
									name='management_id'
									label='Departamento'
									type='text'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
									disabled={true}
									value={selectedPerson?.management ? selectedPerson.management?.name.toUpperCase() : '-'}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									label='Centro de Costo'
									key={'cost_center_id' + costCenterList + costCenterDefault}
									id='cost_center_id'
									name='cost_center_id'
									isRequired={true}
									value={(isEdit ? dataPersonalProtectiveEquipment.cost_center_id : (costCenterDefault?.value || '')) || ''}
									onSelect={() => {}}
									itemsSelect={costCenterList}
									disabled={false}
									validation={validation}
								/>
							</Col>
							{
								(isEdit && ['AGD'].includes(dataPersonalProtectiveEquipment?.personal_protective_equipment_status?.code) && !validation.values.is_regularization)
									? (
										<Row className='g-3'>
											<Col lg={6}>
												<div
													className='form-check'
												>
													<Label
														className='form-check-label'
														for='changeToDelivered'
													>
														Cambiar estado EPP a "Entregado"
													</Label>
													<input
														type='checkbox'
														className='form-check-input'
														id='changeToDelivered'
														checked={validation.values.change_to_delivered}
														onChange={e => {
															validation.setFieldValue(
																'change_to_delivered',
																e.target.checked
															);
														}}
													/>
												</div>
											</Col>
										</Row>
									)
									:
									null
							}
							<React.Fragment>
								<Row className='g-3'>
									<Col lg={6}>
										<div
											className='form-check'
										>
											<Label
												className='form-check-label'
												for='isRegularization'
											>
												¿Es regularización de EPP?
											</Label>
											<input
												type='checkbox'
												className='form-check-input'
												id='isRegularization'
												checked={validation.values.is_regularization}
												onChange={e => {
													validation.setFieldValue(
														'is_regularization',
														e.target.checked
													);
												}}
												disabled={isEdit}
											/>
										</div>
									</Col>
								</Row>
								{validation.values.is_regularization 
									?
									<Row className='gx-3 pt-3'>
										<Col lg={3}>
											<OSelect
												key={'personal_protective_equipment_status_id'}
												label='Estado de EPP'
												id='personal_protective_equipment_status_id'
												name='personal_protective_equipment_status_id'
												isRequired={true}
												value={personalProtectiveEquipmentStatusDefaultRegularization?._id || ''}
												onChange={validation.handleChange}
												onBlur={validation.handleBlur}
												onSelect={setSelectedReason}
												disabled={(
													isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading ||
													personalProtectiveEquipmentStatusDefaultRegularization
												)}
												itemsSelect={[
													...(personalProtectiveEquipmentStatusDefaultRegularization
														? [
															{
																value: personalProtectiveEquipmentStatusDefaultRegularization._id,
																label: personalProtectiveEquipmentStatusDefaultRegularization.name,
																item: personalProtectiveEquipmentStatusDefaultRegularization
															}
														]
														: []
													)
												]}
												validation={validation}
											/>
										</Col>
									</Row>
									: null
								}
							</React.Fragment>
						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<Row>
							<Col lg={3}>
								<Row>
									<Col lg={12} className='p-2'>
										<OSelect
											key={(
												'warehouse_id' +
												selectedEstablishment?._id || ''
											)}
											label="Bodega de Origen"
											id="warehouse_id"
											name="warehouse_id"
											isRequired={true}
											value={validation.values.warehouse_id || ''}
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											onSelect={setSelectedWarehouse}
											requestApi={() => getWarehouseList({ warehouse_type_code: 'FSC', establishment_id: validation.values.establishment_id})}
											validation={validation}
										/>
									</Col>

									<Col lg={12} className='p-2'>
										<Label for='name' className='form-label'>
											Filtrar por Frase
										</Label>
										<Input
											name='phrase'
											id='phrase'
											className='form-control'
											placeholder='Ingrese una frase'
											type='text'
											onChange={handlePhraseFilter}
										/>
									</Col>

									<Col lg={12} className='p-2'>
										{Object.keys(selectedItems).length === 0 && (
											<div className="alert alert-primary alert-dismissible alert-label-icon rounded-label fade show" role="alert">
												<i className="icon-info label-icon"></i>Debe seleccionar al menos un ítem de la bodega para continuar.
											</div>
										)}
									</Col>
								</Row>
							</Col>
							<Col lg={9}>
								{/* Tabla fija con ítems seleccionados */}
								{Object.keys(selectedItems).length > 0 && (
									<Row>
										<Col>
											<h5>Seleccionados</h5>
											<Table bordered size="sm" striped>
												<thead>
													<tr>
														<th className='text-center w-auto'>#</th>
														<th className='text-center w-auto'>NOMBRE</th>
														{/* <th className='text-center w-auto'>TALLA</th> */}
														{(
															!validation.values.is_regularization
																? <th className='text-center w-auto'>DISPONIBLE</th>
																: null
														)}
														<th className='text-center w-auto'>UNIDAD</th>
														<th className='text-center w-auto'>CANTIDAD</th>
													</tr>
												</thead>
												<tbody>
													{Object.entries(selectedItems).map(([id, data]) => {
														const item = filteredDataList.find((i) => i._id === id);
														if (!item || !data) return null;

														const { quantity } = data;

														return (
															<tr key={item._id}>
																<td className='text-center pt-2 pb-2'>
																	<Input
																		type="checkbox"
																		className='form-check-input fs-15'
																		checked
																		onChange={() => handleItemSelect(item._id, item.available)}
																	/>
																</td>
																<td className='pt-3 pb-3'>{item.name}</td>
																{/* <td className='text-center pt-3 pb-3'>{item.size}</td> */}
																{(
																	!validation.values.is_regularization
																		? <td className='text-center pt-3 pb-3'>{item.available}</td>
																		: null
																)}
																
																<td className='text-center pt-3 pb-3'>{item.unit_measurement?.name.toUpperCase()}</td>
																<td className='text-center'>
																	<div className="input-step w-100">
																		<button
																			type="button"
																			className="minus"
																			onClick={() => handleQuantityChange(item._id, quantity - 1, item.available)}
																		>
																			–
																		</button>

																		<Input
																			type="number"
																			className="product-quantity w-100 pt-1 pb-1"
																			value={quantity}
																			onChange={e =>
																					handleQuantityChange(
																						item._id,
																						e.target
																							.value,
																						item.available
																					)
																				}
																			min="1"
																			max={(
																				!validation.values.is_regularization 
																					? item.available 
																					: undefined
																			)}
																		/>

																		<button
																			type="button"
																			className="plus"
																			onClick={() => handleQuantityChange(item._id, quantity + 1, item.available)}
																		>
																			+
																		</button>
																	</div>
																</td>

															</tr>
														);
													})}
												</tbody>
											</Table>
										</Col>
									</Row>
								)}

								{/* Tabla completa con scroll */}
								{filteredDataList.length > 0 ? (
									<Row className="mt-3">
										<Col>
											<SimpleBar style={{ maxHeight: "300px" }}>
												<Table bordered hover striped>
													<thead>
														<tr>
															<th className='text-center'>#</th>
															<th className='text-center'>Nombre</th>
															{/* <th className='text-center'>TALLA</th> */}
															{(
																!validation.values.is_regularization
																	? <th className='text-center'>Disponible</th>
																	: null
															)}
															
															<th className='text-center'>Unidad</th>
															{/* <th>CANTIDAD</th> */}
														</tr>
													</thead>
													<tbody>
														{filteredDataList
															.filter((item) => !selectedItems[item._id])
															.map((item) => (
																<tr key={item._id}>
																	<td>
																		<Input
																			type="checkbox"
																			className='form-check-input fs-15'
																			checked={!!selectedItems[item._id]}
																			disabled={item.available === 0 && !validation.values.is_regularization}
																			onChange={() => handleItemSelect(item._id, item.available)}
																		/>
																	</td>
																	<td>{item.name}</td>
																	{/* <td className='text-center'>{item.size}</td> */}
																	{(
																		!validation.values.is_regularization
																			? <td className='text-center'>{item.available}</td>
																			: null
																	)}
																	<td className='text-center'>{item.unit_measurement?.name.toUpperCase()}</td>
																	{/* <td>
																		{selectedItems[item._id] ? (
																			<Input
																				type="number"
																				min="1"
																				max={item.available}
																				value={selectedItems[item._id]?.quantity || ""}
																				onChange={(e) =>
																					handleQuantityChange(
																						item._id,
																						e.target.value,
																						item.available
																					)
																				}
																			/>
																		) : (
																			"-"
																		)}
																	</td> */}
																</tr>
															))}
													</tbody>
												</Table>
											</SimpleBar>
										</Col>
									</Row>
								) : (
									<Row className="mt-3">
										<Col>
											<div className="text-center text-muted">
												Esta bodega no cuenta con ítems
											</div>
										</Col>
									</Row>
								)}
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId='3'>
						<Row>
							<Col lg={12}>
								<SimpleBar style={{ maxHeight: "300px" }}>
									<ODataGrid
										enableTopToolbar={false}
										columns={columns}
										data={dataListPerson || []}
										nameFile={'asignación_de_epp'}
									/>
								</SimpleBar>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody >
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={loading}
					>
						{loading ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						{isEdit ? 'Editar' : 'Asignar'} Equipamiento de Protección Personal
					</button>
				</div>
			</div>
		</Form >
	);
};

export default PersonalProtectiveEquipmentForm;
